module.exports = __webpack_public_path__ + "static/media/mausam - hot day.3598928b.png";